import { render, staticRenderFns } from "./configurationManagementSub.vue?vue&type=template&id=2a2b4fcc&"
import script from "./configurationManagementSub.vue?vue&type=script&lang=js&"
export * from "./configurationManagementSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2b4fcc')) {
      api.createRecord('2a2b4fcc', component.options)
    } else {
      api.reload('2a2b4fcc', component.options)
    }
    module.hot.accept("./configurationManagementSub.vue?vue&type=template&id=2a2b4fcc&", function () {
      api.rerender('2a2b4fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/configurationManagementSub.vue"
export default component.exports